import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// for Jira
export var getMediaCopyProjectUrl = function getMediaCopyProjectUrl(projectId) {
  return "/rest/api/2/attachment/upload/project/".concat(projectId);
};

// for portal
export var getMediaCopyPortalUrl = function getMediaCopyPortalUrl(portalId) {
  return "/rest/servicedesk/1/customer/portal/".concat(portalId, "/media/upload");
};
export var JSMAttachmentValidationError = /*#__PURE__*/function (_Error) {
  function JSMAttachmentValidationError(message, traceId) {
    var _this;
    _classCallCheck(this, JSMAttachmentValidationError);
    _this = _callSuper(this, JSMAttachmentValidationError, [message]);
    _this.traceId = traceId;
    return _this;
  }
  _inherits(JSMAttachmentValidationError, _Error);
  return _createClass(JSMAttachmentValidationError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
/**
 * Media Picker uploads files into its own service.
 *
 * For them to be available to be attached to a newly created issue, they must be copied/uploaded
 * from a special (Media) collection and made available as a temporary attachment given the projectId.
 *
 * This temporary attachment has it's own id which Jira understands, and we eventually pass this to
 * a Gira GQL endpoint.
 *
 * If an issue has already been created, we can upload it directly, given the issueId.
 */
export var copyToAttachment = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id, file, isProjectId) {
    var url, response, json, message;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = isProjectId ? getMediaCopyProjectUrl(id) : getMediaCopyPortalUrl(id);
          _context.next = 3;
          return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              fileId: file.id
            }),
            headers: {
              'Content-Type': 'application/json'
            }
          });
        case 3:
          response = _context.sent;
          if (response.ok) {
            _context.next = 13;
            break;
          }
          if (!(response.status === 400)) {
            _context.next = 12;
            break;
          }
          _context.next = 8;
          return response.json();
        case 8:
          json = _context.sent;
          message = '';
          if (json.errorMessages && json.errorMessages[0]) {
            // Error from ProjectUrl
            message = json.errorMessages[0];
          } else if (json.errors && json.errors[0].errorMessage) {
            // Error from PortalUrl
            message = json.errors[0].errorMessage;
          }
          throw new JSMAttachmentValidationError(message, response.headers.get('atl-traceid'));
        case 12:
          throw new Error("Response code ".concat(response.status));
        case 13:
          return _context.abrupt("return", response.json());
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function copyToAttachment(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export var getAttachmentsSize = function getAttachmentsSize(files) {
  return files.reduce(function (attachmentsSize, attachment) {
    return attachmentsSize + attachment.size;
  }, 0);
};